const kddiConfig = {
  brand: 'au Soluto',
  scss: './src/styles/kddi',
  assets: './src/assets/kddi',
  logo: 'icon-au',
  locale: 'ja'
};

module.exports = kddiConfig;
